import { ApiData, ApiDescription, RequestsMethod } from '../clientTypes';

export type TimelineCategory =
  | 'enrollment'
  | 'meeting'
  | 'feedback'
  | 'homework'
  | 'email'
  | 'payment'
  | 'university'
  | 'nps'
  | 'flag'
  | 'admin';

export type TimelineTone = 'positive' | 'negative' | 'warning' | 'neutral';

export type TimelineEventDTO = {
  id: string;
  at: string;
  category: TimelineCategory;
  title: string;
  detail?: string;
  tone: TimelineTone;
  sessionId?: string;
  enrollmentId?: string;
};

export const getStudentTimeline: ApiDescription = {
  endpoint: '/users/:id/timeline',
  method: RequestsMethod.Get,
};

export type GetStudentTimeline = ApiData<never, TimelineEventDTO[]>;

export type RiskSignalType =
  | 'never_met'
  | 'inactive'
  | 'no_upcoming_meeting'
  | 'missed_meetings'
  | 'low_mentor_ratings'
  | 'low_parent_feedback'
  | 'low_student_feedback'
  | 'low_nps'
  | 'high_churn_score'
  | 'payment_overdue'
  | 'emails_failing'
  | 'open_flags';

export type RiskLevel = 'high' | 'medium' | 'low';

export type RiskSignalDTO = {
  type: RiskSignalType;
  label: string;
  detail: string;
  weight: number;
};

export type AtRiskStudentDTO = {
  studentId: string;
  name: string;
  email: string;
  graduationYear?: number;
  courses: string[];
  mentors: string[];
  score: number;
  level: RiskLevel;
  signals: RiskSignalDTO[];
  lastMeetingAt?: string;
  nextMeetingAt?: string;
};

export const getAtRiskStudents: ApiDescription = {
  endpoint: '/admin/at-risk-students',
  method: RequestsMethod.Get,
};

export type GetAtRiskStudents = ApiData<
  never,
  { students: AtRiskStudentDTO[]; activeStudents: number; generatedAt: string }
>;
